module.exports = __webpack_public_path__ + "img/login-bg.bc5a2de8.png";